export const contactCls = "contracts_Contactbook";
export const templateCls = "contracts_Template";
export const documentCls = "contracts_Document";
const DEFAULT_THEME_COLOR = "#ef4b26";
const DEFAULT_TENANT_LOGO =
  "https://imgcdn.email-platform.com/danaconnect/logo-danasign.png";
export const themeColor =
  process.env.REACT_APP_PRIMARY_COLOR || DEFAULT_THEME_COLOR;
export const tenantLogoUrl =
  process.env.REACT_APP_TENANT_LOGO_URL || DEFAULT_TENANT_LOGO;
export const iconColor = "#686968";
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const maxFileSize = 15; // 15MB
export const maxTitleLength = 250; // 250 characters
export const maxNoteLength = 1000; // 1000 characters esto hay que cambiarlo en el backend tambien
export const maxDescriptionLength = 500; // 500 characters
export const defaultSignatureValidation = {
  minArea: 1500, // px^2
  minLength: 180, // px
  minAreaFloor: 600,
  minLengthFloor: 80,
  maxArea: 30000,
  maxLength: 2000
};
